document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.getElementById('cartDrawer');
  const overlay = document.getElementById('cartDrawerOverlay');
  const toggle = document.getElementById('cartDrawerToggle');

  if (!drawer || !overlay || !toggle) return;

  function isCartPage() {
    return document.body.classList.contains('template-cart');
  }

  function getContent() {
    return document.getElementById('cartDrawerContent');
  }

  function lockPage() {
    document.body.classList.add('is-cart-drawer-open');
  }

  function unlockPage() {
    document.body.classList.remove('is-cart-drawer-open');
  }

  function openDrawer() {
    if (isCartPage()) return;

    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    lockPage();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    toggle.setAttribute('aria-expanded', 'false');
    unlockPage();
  }

  async function getCart() {
    const response = await fetch('/cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Cache-Control': 'no-cache'
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch cart');
    }

    return await response.json();
  }

  async function updateCartCount() {
    try {
      const cart = await getCart();
      const cartCountEls = document.querySelectorAll('[data-cart-count]');

      cartCountEls.forEach(function (el) {
        el.textContent = cart.item_count;
      });
    } catch (error) {
      console.error('Cart count update error:', error);
    }
  }

  async function refreshDrawer() {
    try {
      const response = await fetch(window.location.pathname + '?section_id=header&_=' + Date.now(), {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Cache-Control': 'no-cache'
        }
      });

      if (!response.ok) {
        throw new Error('Failed to refresh cart drawer');
      }

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newContent = doc.getElementById('cartDrawerContent');
      const currentContent = getContent();

      if (newContent && currentContent) {
        currentContent.innerHTML = newContent.innerHTML;
      } else {
        console.warn('Cart drawer content not found during refresh');
      }

      await updateCartCount();
      bindDrawerActions();
    } catch (error) {
      console.error('Cart drawer refresh error:', error);
    }
  }

  async function changeLineItem(lineKey, quantity) {
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: lineKey,
          quantity: quantity
        })
      });

      if (!response.ok) {
        throw new Error('Cart update failed');
      }

      await response.json();
      await refreshDrawer();
    } catch (error) {
      console.error('Change line item error:', error);
    }
  }

  async function incrementLineItem(lineKey) {
    try {
      const cart = await getCart();
      const item = cart.items.find(function (cartItem) {
        return cartItem.key === lineKey;
      });

      if (!item) return;

      await changeLineItem(lineKey, item.quantity + 1);
    } catch (error) {
      console.error('Increment line item error:', error);
    }
  }

  async function decrementLineItem(lineKey) {
    try {
      const cart = await getCart();
      const item = cart.items.find(function (cartItem) {
        return cartItem.key === lineKey;
      });

      if (!item) return;

      const nextQuantity = Math.max(0, item.quantity - 1);
      await changeLineItem(lineKey, nextQuantity);
    } catch (error) {
      console.error('Decrement line item error:', error);
    }
  }

  function bindDrawerActions() {
    const closeBtn = drawer.querySelector('[data-cart-drawer-close]');
    const removeButtons = drawer.querySelectorAll('[data-cart-remove]');
    const minusButtons = drawer.querySelectorAll('[data-cart-qty-minus]');
    const plusButtons = drawer.querySelectorAll('[data-cart-qty-plus]');

    if (closeBtn) {
      closeBtn.onclick = function () {
        closeDrawer();
      };
    }

    removeButtons.forEach(function (button) {
      button.onclick = function () {
        const key = button.getAttribute('data-line-key');
        if (!key) return;
        changeLineItem(key, 0);
      };
    });

    minusButtons.forEach(function (button) {
      button.onclick = function () {
        const key = button.getAttribute('data-line-key');
        if (!key) return;
        decrementLineItem(key);
      };
    });

    plusButtons.forEach(function (button) {
      button.onclick = function () {
        const key = button.getAttribute('data-line-key');
        if (!key) return;
        incrementLineItem(key);
      };
    });
  }

  toggle.addEventListener('click', function (event) {
    event.preventDefault();

    if (isCartPage()) return;

    if (drawer.classList.contains('is-open')) {
      closeDrawer();
    } else {
      openDrawer();
    }
  });

  overlay.addEventListener('click', function () {
    closeDrawer();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  bindDrawerActions();
  updateCartCount();

  window.CartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshDrawer
  };
});